"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SuccessIcon() {
    return (React.createElement("svg", { "data-qa": "success-icon", width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1" },
        React.createElement("defs", null,
            React.createElement("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M15.6196989,7.75573791 L10.8431733,12.5322249 L8.28345077,9.97390854 L6.69669914,11.5606602 L10.9057039,15.769665 L10.9223693,15.7523892 L10.9562943,15.7863464 L17.3033009,9.43933983 L15.6196989,7.75573791 Z", id: "path-1" })),
        React.createElement("g", { id: "icons/general/success", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "mask-2", fill: "white" },
                React.createElement("use", { xlinkHref: "#path-1" })),
            React.createElement("use", { id: "Combined-Shape", fill: "#DCEB9C", xlinkHref: "#path-1" }),
            React.createElement("g", { id: "colors/black/350_highlight_L", mask: "url(#mask-2)", fill: "#ffffff" },
                React.createElement("rect", { id: "Color", x: "0", y: "0", width: "24", height: "24" })))));
}
exports.SuccessIcon = SuccessIcon;
